import React, { useEffect, useState, useRef } from 'react';
import { useQuery } from '@apollo/react-hooks';
import storeLocatorQuery from '../StoreLocator/StoreLocator.gql';
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from '@react-google-maps/api';
import { LocationStateContext } from '../StoreLocator/StoreLocator';
import LoadingPage from '../LoadingPage';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const MapWrapper = styled('div')`
  height: 40vh;
  width: 100%;
  max-width: 80rem;
  padding: 0 32px;
  margin: auto;
  position: relative;
  overflow: hidden;

  ${theme.below.md} {
    height: 50vh;
    padding: 0 16px;
  }

  .map-container {
    height: 100%;
    width: 100%;
    ${theme.below.md} {
      height: 100%;
    }
  }
`;

const LoadingElement = () => <div style={{ height: '100%' }}></div>;

export const Map = ({ title, storeID = 11 }) => {
  const { data = {}, loading = true } = useQuery(storeLocatorQuery);
  const [specificStore, setSpecificStore] = useState(null);
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const mapRef = useRef(null);
  const googleMapsApiKey = 'AIzaSyBSnoAk0yy_v4RTlSwKl51HfD8uf4F2mg0';

  // Create a minimal location state
  const locationState = {
    activeLocation: null,
    expandedLocation: null,
    setHighlightedLocation: () => {},
    toggleExpandedLocation: () => {},
  };

  // Find the specific store by ID
  useEffect(() => {
    if (data?.stores && data.stores.length > 0) {
      const foundStore = data.stores.find(
        (store) => parseInt(store.id) === parseInt(storeID)
      );

      if (foundStore) {
        console.log('Found specific store:', foundStore);
        console.log('Store coordinates:', foundStore.coordinates);
        setSpecificStore(foundStore);
      } else {
        console.log('Store with ID', storeID, 'not found');
      }
    }
  }, [data, storeID]);

  if (loading) return <LoadingPage />;

  // Default coordinates in Sweden
  const defaultLat = 59.247948;
  const defaultLng = 14.755806;

  // Get coordinates from the specific store if available
  const latitude = specificStore?.coordinates?.latitude
    ? parseFloat(specificStore.coordinates.latitude)
    : defaultLat;

  const longitude = specificStore?.coordinates?.longitude
    ? parseFloat(specificStore.coordinates.longitude)
    : defaultLng;

  console.log('Final coordinates type:', typeof latitude, typeof longitude);
  console.log('Final coordinates:', latitude, longitude);

  // Explicitly create a center object for the map
  const center = {
    lat: latitude,
    lng: longitude,
  };

  console.log('Center object:', center);

  return (
    <MapWrapper>
      {title?.value && <h1>{title.value}</h1>}

      <LocationStateContext.Provider value={locationState}>
        <LoadScript
          loadingElement={<LoadingElement />}
          preventGoogleFontsLoading={true}
          googleMapsApiKey={googleMapsApiKey}
        >
          <GoogleMap
            mapContainerClassName="map-container"
            center={center}
            zoom={14}
            onLoad={(map) => {
              console.log('Map loaded successfully');
              mapRef.current = map;
            }}
            options={{
              disableDefaultUI: false,
              zoomControl: true,
            }}
          >
            {specificStore && (
              <>
                <Marker
                  position={center}
                  onClick={() => setShowInfoWindow(true)}
                />
                {showInfoWindow && (
                  <InfoWindow
                    position={center}
                    onCloseClick={() => setShowInfoWindow(false)}
                  >
                    <div style={{ padding: '10px', maxWidth: '200px' }}>
                      <h3>{specificStore.name}</h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: specificStore.address1,
                        }}
                      />
                    </div>
                  </InfoWindow>
                )}
              </>
            )}
          </GoogleMap>
        </LoadScript>
      </LocationStateContext.Provider>
    </MapWrapper>
  );
};

export default Map;
